import React from "react";
import {GithubIcon} from './Icons'

const ProjectCard = ({ project }) => (
  <div className="bg-gray-800 rounded-xl shadow-2xl overflow-hidden transform transition duration-500 hover:scale-[1.02] hover:shadow-indigo-500/50 flex flex-col">
    <img 
      src={project.imageUrl} 
      alt={`Preview of ${project.title}`} 
      className="w-full h-48 object-cover" 
      onError={(e) => e.target.src='https://placehold.co/400x250/4f46e5/ffffff?text=Image+Missing'} // Fallback
    />
    <div className="p-6 flex flex-col flex-grow">
      <h3 className="text-2xl font-bold text-indigo-400 mb-3">{project.title}</h3>
      <p className="text-gray-300 mb-4 flex-grow">{project.description}</p>
      <div className="flex flex-wrap gap-2 mb-4">
        {project.tags.map(tag => (
          <span key={tag} className="px-3 py-1 bg-gray-700 text-xs font-medium text-gray-200 rounded-full">
            {tag}
          </span>
        ))}
      </div>
      <a 
        href={project.githubUrl} 
        target="_blank" 
        rel="noopener noreferrer" 
        className="mt-auto inline-flex items-center justify-center bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-4 rounded-lg transition duration-300"
      >
        <GithubIcon size={20} className="mr-2" /> View Code
      </a>
    </div>
  </div>
);

export default ProjectCard